import { SERVER_BASE_URL } from '../config/app.config';
import axios from 'axios';
import { GetToken } from '../auth/Auth';

const serverClient = axios.create({
    baseURL: `${SERVER_BASE_URL}`,
    timeout: 12000,
});

serverClient.defaults.headers.common['Accept'] = 'application/json';

// Dynamically set the Authorization header for each request
serverClient.interceptors.request.use(
    (config) => {
        const token = GetToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default serverClient;
